import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/getTrafficInformationFromAddress'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class getTrafficInformationFromAddressStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "getTrafficInformationFromAddressStore",
			variables: true,
		})
	}
}

export async function load_getTrafficInformationFromAddress(params) {
  await initClient()

	const store = new getTrafficInformationFromAddressStore()

	await store.fetch(params)

	return {
		getTrafficInformationFromAddress: store,
	}
}
